import qs from 'qs'
import React, { useState, useEffect, useCallback } from 'react'
import withStyles from '@mui/styles/withStyles'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'

import * as medicRegistrationHttp from '../http/medicregistration'
import Loading from '../components/Loading'

const styles = theme => ({
  appBar: { zIndex: theme.zIndex.drawer + 1 },
  title: { flexGrow: 1, paddingLeft: 24 },
  // O aviso de cookies e fixo no rodape e cobria o botao de enviar.
  // Quem chega aqui vem por link, quase sempre em janela nova, entao
  // ve o aviso SEMPRE -- diferente do sistema logado, onde aparece uma
  // vez so. A folga embaixo garante que o formulario nao fique sob ele.
  content: {
    maxWidth: 620, margin: '32px auto', padding: theme.spacing(3),
    paddingBottom: 140
  }
})

function readUrlQuery(search) {
  return qs.parse(search, { ignoreQueryPrefix: true })
}

// Página aberta pelo link do e-mail de liberação. O código do equipamento só
// existe depois que o médico instala e abre o ImagiPACS Uni, por isso ele não
// é pedido no formulário de cadastro.
function HwidSubmission(props) {
  const { classes } = props
  const token = readUrlQuery(props.location ? props.location.search : '').token

  const [carregando, setCarregando] = useState(true)
  const [valido, setValido] = useState(false)
  const [erroToken, setErroToken] = useState(null)
  const [nomeMedico, setNomeMedico] = useState('')
  const [hwid, setHwid] = useState('')
  const [erro, setErro] = useState(null)
  const [enviado, setEnviado] = useState(false)

  useEffect(() => {
    const validar = async () => {
      if (!token) {
        setErroToken('Link inválido: token não informado.')
        setCarregando(false)
        return
      }
      const { result, data } = await medicRegistrationHttp.validateHwidToken(token)
      if (result && data.valid) {
        setValido(true)
        setNomeMedico(data.medic_name || '')
      } else {
        setErroToken((data && data.message) || 'Link inválido.')
      }
      setCarregando(false)
    }
    validar()
  }, [token])

  const enviar = useCallback(async evento => {
    evento.preventDefault()
    setErro(null)
    if (!hwid.trim()) {
      setErro('Informe o código exibido pelo ImagiPACS Uni.')
      return
    }
    setCarregando(true)
    const { result, data } = await medicRegistrationHttp.submitHwid(token, hwid.trim())
    setCarregando(false)
    if (result) {
      setEnviado(true)
    } else {
      setErro((data && data.message) || 'Não foi possível enviar o código.')
    }
  }, [hwid, token])

  const cabecalho = (
    <AppBar position="static" className={classes.appBar} style={{ background: '#58b0c0' }}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          Código do equipamento - IMAGIRIS
        </Typography>
      </Toolbar>
    </AppBar>
  )

  if (carregando) {
    return <React.Fragment>{cabecalho}<Loading /></React.Fragment>
  }

  if (erroToken) {
    return (
      <React.Fragment>{cabecalho}
        <Paper className={classes.content}>
          <Alert severity="warning">{erroToken}</Alert>
        </Paper>
      </React.Fragment>
    )
  }

  if (enviado) {
    return (
      <React.Fragment>{cabecalho}
        <Paper className={classes.content}>
          <Alert severity="success">
            Código recebido, obrigado! Nossa equipe finalizará a liberação do
            acesso às imagens.
          </Alert>
        </Paper>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>{cabecalho}
      {valido && (
        <Paper className={classes.content}>
          <Typography variant="h6" gutterBottom>
            {nomeMedico ? 'Olá, ' + nomeMedico + '!' : 'Olá!'}
          </Typography>
          <Typography paragraph color="textSecondary">
            Abra o ImagiPACS Uni no computador que você usará para ver as
            imagens. Na primeira execução ele exibe um código do equipamento —
            informe esse código abaixo.
          </Typography>

          {erro && <Box mb={2}><Alert severity="error">{erro}</Alert></Box>}

          <form onSubmit={enviar}>
            <TextField
              label="Código do equipamento"
              value={hwid}
              onChange={e => setHwid(e.target.value)}
              fullWidth
              autoFocus
            />
            <Box mt={3}>
              <Button type="submit" variant="contained"
                style={{ background: '#58b0c0', color: 'white' }}>
                Enviar código
              </Button>
            </Box>
          </form>
        </Paper>
      )}
    </React.Fragment>
  )
}

export default withStyles(styles)(HwidSubmission)
